

































import { RedactModule } from '@/store/modules/redact';
import { IMenu } from '@/types/menu';
import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator';
@Component({})
export default class ExportDataDialog extends Vue {
  @Prop()
  visible: boolean = false;

  startDate = null;
  endDate = null;

  handleChange() {}
}
